/** Shared in-view fade for the story sections; skipped under reduced motion. */
export function fadeIn(reduce: boolean | null, delay = 0) {
  return reduce
    ? {}
    : {
        initial: { opacity: 0, y: 14 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-60px" },
        transition: { duration: 0.5, delay },
      };
}
